import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '../styles/console.css'
import '../styles/print.css'
import { App } from './App.tsx'
import { ThemeProvider } from '../lib/hooks.tsx'
import { PublicWorldProvider } from './context.tsx'
import { setViewTransitions } from '../lib/router.tsx'
import { StatusProvider } from './ui/primitives.tsx'

setViewTransitions(false)

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <ThemeProvider>
      <StatusProvider>
        <PublicWorldProvider>
          <App />
        </PublicWorldProvider>
      </StatusProvider>
    </ThemeProvider>
  </StrictMode>,
)
